import React from 'react';
import Tab from './tab/tab';
import { TTabs } from '../../q-a/qanda';

interface IProps {
  tabs: TTabs[];
  selected: string;
  component: React.ElementType;
}

const Tabs: React.FC<IProps> = ({ tabs, selected, component: Component }): JSX.Element => {
  return (
    <>
      {tabs.map((tab: TTabs) => {
        return (
          <Tab isSelected={ selected === tab.title } key={tab.title}>
            <Component {...tab}/>
          </Tab>
        );
      })}
    </>
  );
};

export default Tabs;
